/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {queryTopicByDisplayDate} from '../api'

export const useMutationQueryTopicByDisplayDate = createReactQueryMutationHook('queryTopicByDisplayDate', queryTopicByDisplayDate)
